export const getManyProductsByManySkus = (skus: string[], country?: string) => {
  if (!skus || !(skus instanceof Array)) {
    throw new Error(`Must provide handles to queryGetManyProductsBySKU; provided: ${typeof skus === 'object' ? JSON.stringify(skus) : skus} `)
  }

  const normalizedCountry = typeof country === 'string' && country.trim()
    ? country.trim().toUpperCase()
    : ''

  const variables = {
    query: skus
      .filter(Boolean)
      .map((sku) => `variants.sku:"${sku.replace(/"/g, '\\"')}"`)
      .join(' OR '),
    first: 100,
    ...(normalizedCountry ? { country: normalizedCountry } : {})
  }

  const querySignature = normalizedCountry
    ? 'query searchProducts($query: String!, $first: Int, $country: CountryCode!) @inContext(country: $country) {'
    : 'query searchProducts($query: String!, $first: Int) {'

  const query = `
    ${querySignature}
      search(query:$query, types: PRODUCT, first: $first) {
        nodes {
          ... on Product {
            id
            title
            handle
            tags
            productBiline: metafield(namespace: "custom", key: "product_bi_line") {
              value
            }
            variants (first: 100) {
              nodes {
                id
                availableForSale
                sku
                price {
                  amount
                  currencyCode
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  `

  return { query, variables }
}
